// @ts-nocheck
import React, { useState } from 'react';
import { ArrowRight, Shield, Building, Home, Leaf, Calculator, PieChart, ExternalLink } from 'lucide-react';

const SOeasiSimulator = ({ onCompleteProfile, onStartBilanComplete }) => {
  const [currentView, setCurrentView] = useState('profiling');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);

  // Questions de profiling
  const profilingQuestions = [
    {
      id: 'personalInfo',
      question: "Informations Personnelles",
      type: 'multiple',
      subQuestions: [
        {
          id: 'ageRange',
          question: "Quelle est votre tranche d'âge ?",
          type: 'choice',
          options: [
            { value: '18-30', label: "18-30", risk: 8 },
            { value: '31-45', label: "31-45", risk: 6 },
            { value: '46-60', label: "46-60", risk: 4 },
            { value: '60+', label: "60+", risk: 2 }
          ]
        },
        {
          id: 'profession',
          question: "Quelle est votre catégorie socio-professionnelle ?",
          type: 'choice',
          options: [
            { value: 'employee', label: "Employé", risk: 4 },
            { value: 'executive', label: "Cadre/Profession libérale", risk: 6 },
            { value: 'entrepreneur', label: "Indépendant/Entrepreneur", risk: 7 },
            { value: 'retired', label: "Retraité", risk: 2 },
            { value: 'other', label: "Autre", risk: 5 }
          ]
        }
      ]
    },
    {
      id: 'financialSituation',
      question: "Situation Financière",
      type: 'multiple',
      subQuestions: [
        {
          id: 'annualIncome',
          question: "Quel est votre revenu annuel net ?",
          type: 'choice',
          options: [
            { value: 'less-30k', label: "Moins de 30k€", risk: 7 },
            { value: '30k-60k', label: "30k€ - 60k€", risk: 6 },
            { value: '60k-100k', label: "60k€ - 100k€", risk: 5 },
            { value: 'more-100k', label: "Plus de 100k€", risk: 3 }
          ]
        },
        {
          id: 'monthlySavings',
          question: "Combien épargnez-vous par mois ?",
          type: 'choice',
          options: [
            { value: 'less-200', label: "Moins de 200€", risk: 7 },
            { value: '200-500', label: "200€ - 500€", risk: 6 },
            { value: '500-1000', label: "500€ - 1000€", risk: 5 },
            { value: 'more-1000', label: "Plus de 1000€", risk: 3 }
          ]
        },
        {
          id: 'financialAssets',
          question: "Quelle est la valeur de votre patrimoine financier (hors résidence principale) ?",
          type: 'choice',
          options: [
            { value: 'less-10k', label: "Moins de 10k€", risk: 7 },
            { value: '10k-50k', label: "10k€ - 50k€", risk: 6 },
            { value: '50k-250k', label: "50k€ - 250k€", risk: 5 },
            { value: 'more-250k', label: "Plus de 250k€", risk: 3 }
          ]
        }
      ]
    },
    {
      id: 'objectivesHorizon',
      question: "Objectifs et Horizon",
      type: 'multiple',
      subQuestions: [
        {
          id: 'investmentObjective',
          question: "Quel est votre principal objectif d'investissement ?",
          type: 'choice',
          options: [
            { value: 'retirement', label: "Préparer ma retraite", risk: 6 },
            { value: 'capital-growth', label: "Faire fructifier mon capital", risk: 7 },
            { value: 'income', label: "Générer un revenu complémentaire", risk: 5 },
            { value: 'specific-project', label: "Projet spécifique (achat immobilier, etc.)", risk: 4 }
          ]
        },
        {
          id: 'timeHorizon',
          question: "Sur quel horizon de temps souhaitez-vous investir ?",
          type: 'choice',
          options: [
            { value: 'short-term', label: "Court terme (moins de 3 ans)", risk: 3 },
            { value: 'medium-term', label: "Moyen terme (3-8 ans)", risk: 5 },
            { value: 'long-term', label: "Long terme (plus de 8 ans)", risk: 7 }
          ]
        }
      ]
    },
    {
      id: 'riskAppetite',
      question: "Appétence au Risque",
      type: 'multiple',
      subQuestions: [
        {
          id: 'marketKnowledge',
          question: "Quelle est votre connaissance des marchés financiers ?",
          type: 'choice',
          options: [
            { value: 'beginner', label: "Débutant", risk: 2 },
            { value: 'intermediate', label: "Intermédiaire", risk: 4 },
            { value: 'confirmed', label: "Confirmé", risk: 6 },
            { value: 'expert', label: "Expert", risk: 8 }
          ]
        },
        {
          id: 'lossReaction',
          question: "Comment réagiriez-vous si votre portefeuille perdait 15% en un mois ?",
          type: 'choice',
          options: [
            { value: 'sell-all', label: "Je vends tout pour sécuriser ce qu'il reste", risk: 1 },
            { value: 'sell-part', label: "Je vends une partie", risk: 3 },
            { value: 'wait', label: "Je ne fais rien et attends", risk: 6 },
            { value: 'buy-more', label: "Je profite de la baisse pour investir plus", risk: 8 }
          ]
        },
        {
          id: 'returnRisk',
          question: "Quel couple rendement/risque préférez-vous ?",
          type: 'choice',
          options: [
            { value: 'low-low', label: "Rendement faible, risque très faible", risk: 2 },
            { value: 'moderate-moderate', label: "Rendement modéré, risque modéré", risk: 5 },
            { value: 'high-high', label: "Rendement élevé, risque élevé", risk: 8 }
          ]
        }
      ]
    }
  ];


  // Calculs
  const calculateRiskProfile = (answersArray) => {
    if (answersArray.length === 0) return 5;
    const riskScores = answersArray.map(answer => {
      return answer.risk || 5;
    });
    return Math.round(riskScores.reduce((sum, score) => sum + score, 0) / riskScores.length);
  };


  // Composant de profiling
  const ProfilingView = () => {
    const question = profilingQuestions[currentQuestion];
    
    const handleAnswer = (value, additionalData = {}) => {
      const newAnswer = {
        questionId: question.id,
        value: value,
        ...additionalData
      };
      
      const newAnswers = [...answers];
      const existingIndex = newAnswers.findIndex(a => a.questionId === question.id);
      
      if (existingIndex >= 0) {
        newAnswers[existingIndex] = newAnswer;
      } else {
        newAnswers.push(newAnswer);
      }
      
      setAnswers(newAnswers);
      
      if (currentQuestion < profilingQuestions.length - 1) {
        setTimeout(() => setCurrentQuestion(currentQuestion + 1), 500);
      } else {
        // Préparer les données du profil utilisateur
        const profileData = {
          answers: newAnswers,
          riskProfile: calculateRiskProfile(newAnswers),
          ageRange: newAnswers.find(a => a.questionId === 'ageRange')?.value || '31-45',
          profession: newAnswers.find(a => a.questionId === 'profession')?.value || 'employee',
          income: newAnswers.find(a => a.questionId === 'income')?.value || 3500,
          objective: newAnswers.find(a => a.questionId === 'objective')?.value || 'wealth',
          experience: newAnswers.find(a => a.questionId === 'experience')?.value || 'intermediate'
        };
        setTimeout(() => setCurrentView('simulation'), 1000);
      }
    };

    const handleMultipleAnswer = (subQuestionId, value, additionalData = {}) => {
      const newAnswer = {
        questionId: subQuestionId,
        value: value,
        ...additionalData
      };
      
      const newAnswers = [...answers];
      const existingIndex = newAnswers.findIndex(a => a.questionId === subQuestionId);
      
      if (existingIndex >= 0) {
        newAnswers[existingIndex] = newAnswer;
      } else {
        newAnswers.push(newAnswer);
      }
      
      setAnswers(newAnswers);
    };

    const handleMultipleNext = () => {
      const question = profilingQuestions[currentQuestion];
      
      if (question.id === 'personalInfo') {
        // Vérifier que les deux questions sont répondues
        const ageAnswer = answers.find(a => a.questionId === 'ageRange');
        const professionAnswer = answers.find(a => a.questionId === 'profession');
        
        if (ageAnswer && professionAnswer) {
          if (currentQuestion < profilingQuestions.length - 1) {
            setTimeout(() => setCurrentQuestion(currentQuestion + 1), 500);
          } else {
            // Préparer les données du profil utilisateur
            const profileData = {
              answers: answers,
              riskProfile: calculateRiskProfile(answers),
              ageRange: ageAnswer.value,
              profession: professionAnswer.value,
              annualIncome: answers.find(a => a.questionId === 'annualIncome')?.value || 'less-30k',
              monthlySavings: answers.find(a => a.questionId === 'monthlySavings')?.value || 'less-200',
              financialAssets: answers.find(a => a.questionId === 'financialAssets')?.value || 'less-10k',
              objective: answers.find(a => a.questionId === 'objective')?.value || 'wealth',
              experience: answers.find(a => a.questionId === 'experience')?.value || 'intermediate'
            };
            setTimeout(() => setCurrentView('simulation'), 1000);
          }
        }
      } else if (question.id === 'financialSituation') {
        // Vérifier que les trois questions financières sont répondues
        const annualIncomeAnswer = answers.find(a => a.questionId === 'annualIncome');
        const monthlySavingsAnswer = answers.find(a => a.questionId === 'monthlySavings');
        const financialAssetsAnswer = answers.find(a => a.questionId === 'financialAssets');
        
        if (annualIncomeAnswer && monthlySavingsAnswer && financialAssetsAnswer) {
          if (currentQuestion < profilingQuestions.length - 1) {
            setTimeout(() => setCurrentQuestion(currentQuestion + 1), 500);
          } else {
            // Préparer les données du profil utilisateur
            const profileData = {
              answers: answers,
              riskProfile: calculateRiskProfile(answers),
              ageRange: answers.find(a => a.questionId === 'ageRange')?.value || '31-45',
              profession: answers.find(a => a.questionId === 'profession')?.value || 'employee',
              annualIncome: annualIncomeAnswer.value,
              monthlySavings: monthlySavingsAnswer.value,
              financialAssets: financialAssetsAnswer.value,
              objective: answers.find(a => a.questionId === 'objective')?.value || 'wealth',
              experience: answers.find(a => a.questionId === 'experience')?.value || 'intermediate'
            };
            setTimeout(() => setCurrentView('simulation'), 1000);
          }
        }
      } else if (question.id === 'objectivesHorizon') {
        // Vérifier que les deux questions objectifs/horizon sont répondues
        const objectiveAnswer = answers.find(a => a.questionId === 'investmentObjective');
        const horizonAnswer = answers.find(a => a.questionId === 'timeHorizon');
        
        if (objectiveAnswer && horizonAnswer) {
          if (currentQuestion < profilingQuestions.length - 1) {
            setTimeout(() => setCurrentQuestion(currentQuestion + 1), 500);
          } else {
            // Préparer les données du profil utilisateur
            const profileData = {
              answers: answers,
              riskProfile: calculateRiskProfile(answers),
              ageRange: answers.find(a => a.questionId === 'ageRange')?.value || '31-45',
              profession: answers.find(a => a.questionId === 'profession')?.value || 'employee',
              annualIncome: answers.find(a => a.questionId === 'annualIncome')?.value || 'less-30k',
              monthlySavings: answers.find(a => a.questionId === 'monthlySavings')?.value || 'less-200',
              financialAssets: answers.find(a => a.questionId === 'financialAssets')?.value || 'less-10k',
              investmentObjective: objectiveAnswer.value,
              timeHorizon: horizonAnswer.value,
              marketKnowledge: answers.find(a => a.questionId === 'marketKnowledge')?.value || 'beginner',
              lossReaction: answers.find(a => a.questionId === 'lossReaction')?.value || 'wait',
              returnRisk: answers.find(a => a.questionId === 'returnRisk')?.value || 'moderate-moderate'
            };
            setTimeout(() => setCurrentView('simulation'), 1000);
          }
        }
      } else if (question.id === 'riskAppetite') {
        // Vérifier que les trois questions d'appétence au risque sont répondues
        const knowledgeAnswer = answers.find(a => a.questionId === 'marketKnowledge');
        const reactionAnswer = answers.find(a => a.questionId === 'lossReaction');
        const returnRiskAnswer = answers.find(a => a.questionId === 'returnRisk');
        
        if (knowledgeAnswer && reactionAnswer && returnRiskAnswer) {
          // Préparer les données du profil utilisateur
          const profileData = {
            answers: answers,
            riskProfile: calculateRiskProfile(answers),
            ageRange: answers.find(a => a.questionId === 'ageRange')?.value || '31-45',
            profession: answers.find(a => a.questionId === 'profession')?.value || 'employee',
            annualIncome: answers.find(a => a.questionId === 'annualIncome')?.value || 'less-30k',
            monthlySavings: answers.find(a => a.questionId === 'monthlySavings')?.value || 'less-200',
            financialAssets: answers.find(a => a.questionId === 'financialAssets')?.value || 'less-10k',
            investmentObjective: answers.find(a => a.questionId === 'investmentObjective')?.value || 'retirement',
            timeHorizon: answers.find(a => a.questionId === 'timeHorizon')?.value || 'medium-term',
            marketKnowledge: knowledgeAnswer.value,
            lossReaction: reactionAnswer.value,
            returnRisk: returnRiskAnswer.value
          };
          setTimeout(() => setCurrentView('simulation'), 1000);
        }
      }
    };

    return (
      <div className="soeasi-question">
        {/* Header avec logo et titre */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '1rem',
            marginBottom: '1rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Leaf style={{ width: '24px', height: '24px', color: '#14b8a6' }} />
            </div>
            <div>
              <h1 style={{
                fontSize: '2rem',
                fontWeight: 'bold',
                background: 'linear-gradient(135deg, #14b8a6 0%, #3b82f6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                margin: 0
              }}>SOeasi</h1>
              <p style={{ color: '#6b7280', margin: 0, fontSize: '0.875rem' }}>
                Finance islamique et éthique
              </p>
            </div>
          </div>
        </div>

        {/* Bulles d'avancement */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '1rem',
          marginBottom: '3rem'
        }}>
          {profilingQuestions.map((_, index) => (
            <React.Fragment key={index}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: index <= currentQuestion 
                  ? 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)'
                  : index === profilingQuestions.length 
                    ? '#e5e7eb' 
                    : '#e5e7eb',
                color: index <= currentQuestion ? 'white' : '#9ca3af',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}>
                {index + 1}
              </div>
              {index < profilingQuestions.length - 1 && (
                <div style={{
                  width: '40px',
                  height: '2px',
                  background: index < currentQuestion ? '#14b8a6' : '#e5e7eb'
                }} />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mb-8">
          {question.type === 'multiple' && (
            <div>
              {/* Titre de section */}
              <div className="mb-6 text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">{question.question}</h2>
                <p className="text-gray-600">Pour mieux vous connaître, merci de répondre aux questions suivantes.</p>
              </div>

              {/* Questions pour Informations Personnelles */}
              {question.id === 'personalInfo' && (
                <>
                  {/* Première question : Tranche d'âge */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[0].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[0].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('ageRange', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'ageRange')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Deuxième question : Catégorie socio-professionnelle */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[1].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[1].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('profession', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'profession')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Questions pour Situation Financière */}
              {question.id === 'financialSituation' && (
                <>
                  {/* Première question : Revenu annuel */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[0].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[0].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('annualIncome', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'annualIncome')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Deuxième question : Épargne mensuelle */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[1].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[1].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('monthlySavings', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'monthlySavings')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Troisième question : Patrimoine financier */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[2].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[2].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('financialAssets', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'financialAssets')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Questions pour Objectifs et Horizon */}
              {question.id === 'objectivesHorizon' && (
                <>
                  {/* Première question : Objectif d'investissement */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[0].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[0].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('investmentObjective', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'investmentObjective')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Deuxième question : Horizon de temps */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[1].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[1].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('timeHorizon', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'timeHorizon')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Questions pour Appétence au Risque */}
              {question.id === 'riskAppetite' && (
                <>
                  {/* Première question : Connaissance des marchés */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[0].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[0].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('marketKnowledge', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'marketKnowledge')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Deuxième question : Réaction à une perte */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[1].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[1].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('lossReaction', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'lossReaction')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Troisième question : Couple rendement/risque */}
                  <div className="mb-8">
                    <h3 className="question-title">{question.subQuestions[2].question}</h3>
                    <div className="choices-grid">
                      {question.subQuestions[2].options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleMultipleAnswer('returnRisk', option.value, option)}
                          className={`choice-button ${answers.find(a => a.questionId === 'returnRisk')?.value === option.value ? 'selected' : ''}`}
                        >
                          <div className="font-semibold text-gray-800">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Boutons de navigation */}
              <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                <button
                  onClick={() => currentQuestion > 0 && setCurrentQuestion(currentQuestion - 1)}
                  disabled={currentQuestion === 0}
                  style={{
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db',
                    background: currentQuestion === 0 ? '#f3f4f6' : 'white',
                    color: currentQuestion === 0 ? '#9ca3af' : '#374151',
                    cursor: currentQuestion === 0 ? 'not-allowed' : 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Précédent
                </button>
                <button
                  onClick={handleMultipleNext}
                  disabled={
                    (question.id === 'personalInfo' && (!answers.find(a => a.questionId === 'ageRange') || !answers.find(a => a.questionId === 'profession'))) ||
                    (question.id === 'financialSituation' && (!answers.find(a => a.questionId === 'annualIncome') || !answers.find(a => a.questionId === 'monthlySavings') || !answers.find(a => a.questionId === 'financialAssets'))) ||
                    (question.id === 'objectivesHorizon' && (!answers.find(a => a.questionId === 'investmentObjective') || !answers.find(a => a.questionId === 'timeHorizon'))) ||
                    (question.id === 'riskAppetite' && (!answers.find(a => a.questionId === 'marketKnowledge') || !answers.find(a => a.questionId === 'lossReaction') || !answers.find(a => a.questionId === 'returnRisk')))
                  }
                  className="nav-button primary"
                  style={{ 
                    flex: 1,
                    opacity: (
                      (question.id === 'personalInfo' && (!answers.find(a => a.questionId === 'ageRange') || !answers.find(a => a.questionId === 'profession'))) ||
                      (question.id === 'financialSituation' && (!answers.find(a => a.questionId === 'annualIncome') || !answers.find(a => a.questionId === 'monthlySavings') || !answers.find(a => a.questionId === 'financialAssets'))) ||
                      (question.id === 'objectivesHorizon' && (!answers.find(a => a.questionId === 'investmentObjective') || !answers.find(a => a.questionId === 'timeHorizon'))) ||
                      (question.id === 'riskAppetite' && (!answers.find(a => a.questionId === 'marketKnowledge') || !answers.find(a => a.questionId === 'lossReaction') || !answers.find(a => a.questionId === 'returnRisk')))
                    ) ? 0.5 : 1,
                    cursor: (
                      (question.id === 'personalInfo' && (!answers.find(a => a.questionId === 'ageRange') || !answers.find(a => a.questionId === 'profession'))) ||
                      (question.id === 'financialSituation' && (!answers.find(a => a.questionId === 'annualIncome') || !answers.find(a => a.questionId === 'monthlySavings') || !answers.find(a => a.questionId === 'financialAssets'))) ||
                      (question.id === 'objectivesHorizon' && (!answers.find(a => a.questionId === 'investmentObjective') || !answers.find(a => a.questionId === 'timeHorizon'))) ||
                      (question.id === 'riskAppetite' && (!answers.find(a => a.questionId === 'marketKnowledge') || !answers.find(a => a.questionId === 'lossReaction') || !answers.find(a => a.questionId === 'returnRisk')))
                    ) ? 'not-allowed' : 'pointer'
                  }}
                >
                  Suivant
                </button>
              </div>
            </div>
          )}

          {question.type === 'slider' && (
            <div>
              <h3 className="question-title">{question.question}</h3>
              <div className="slider-container">
                <div className="flex justify-center mb-4">
                  <span className="text-4xl font-bold text-teal-600">
                    {answers.find(a => a.questionId === question.id)?.value || question.default}
                  </span>
                </div>
                <input
                  type="range"
                  min={question.min}
                  max={question.max}
                  value={answers.find(a => a.questionId === question.id)?.value || question.default}
                  onChange={(e) => handleAnswer(parseInt(e.target.value))}
                  className="slider"
                />
                <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                  <button
                    onClick={() => currentQuestion > 0 && setCurrentQuestion(currentQuestion - 1)}
                    disabled={currentQuestion === 0}
                    style={{
                      padding: '0.75rem 1.5rem',
                      borderRadius: '8px',
                      border: '1px solid #d1d5db',
                      background: currentQuestion === 0 ? '#f3f4f6' : 'white',
                      color: currentQuestion === 0 ? '#9ca3af' : '#374151',
                      cursor: currentQuestion === 0 ? 'not-allowed' : 'pointer',
                      fontWeight: '500'
                    }}
                  >
                    Précédent
                  </button>
                  <button
                    onClick={() => handleAnswer(answers.find(a => a.questionId === question.id)?.value || question.default)}
                    className="nav-button primary"
                    style={{ flex: 1 }}
                  >
                    Suivant
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {question.type === 'choice' && (
            <div>
              <h3 className="question-title">{question.question}</h3>
              <div className="choices-grid">
                {question.options.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleAnswer(option.value, option)}
                    className="choice-button"
                  >
                    <div className="font-semibold text-gray-800">{option.label}</div>
                  </button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                <button
                  onClick={() => currentQuestion > 0 && setCurrentQuestion(currentQuestion - 1)}
                  disabled={currentQuestion === 0}
                  style={{
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db',
                    background: currentQuestion === 0 ? '#f3f4f6' : 'white',
                    color: currentQuestion === 0 ? '#9ca3af' : '#374151',
                    cursor: currentQuestion === 0 ? 'not-allowed' : 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Précédent
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Fonction pour calculer l'allocation basée sur le profil
  const calculateAllocation = () => {
    const ageAnswer = answers.find(a => a.questionId === 'ageRange');
    const professionAnswer = answers.find(a => a.questionId === 'profession');
    const incomeAnswer = answers.find(a => a.questionId === 'annualIncome');
    const savingsAnswer = answers.find(a => a.questionId === 'monthlySavings');
    const assetsAnswer = answers.find(a => a.questionId === 'financialAssets');
    const goalAnswer = answers.find(a => a.questionId === 'investmentObjective');
    const horizonAnswer = answers.find(a => a.questionId === 'timeHorizon');
    const knowledgeAnswer = answers.find(a => a.questionId === 'marketKnowledge');
    const lossAnswer = answers.find(a => a.questionId === 'lossReaction');
    const returnRiskAnswer = answers.find(a => a.questionId === 'returnRisk');

    // Calcul du score de risque global
    let riskScore = 0;
    let totalFactors = 0;

    if (ageAnswer && ageAnswer.risk) { riskScore += ageAnswer.risk; totalFactors++; }
    if (professionAnswer && professionAnswer.risk) { riskScore += professionAnswer.risk; totalFactors++; }
    if (incomeAnswer && incomeAnswer.risk) { riskScore += incomeAnswer.risk; totalFactors++; }
    if (savingsAnswer && savingsAnswer.risk) { riskScore += savingsAnswer.risk; totalFactors++; }
    if (assetsAnswer && assetsAnswer.risk) { riskScore += assetsAnswer.risk; totalFactors++; }
    if (goalAnswer && goalAnswer.risk) { riskScore += goalAnswer.risk; totalFactors++; }
    if (horizonAnswer && horizonAnswer.risk) { riskScore += horizonAnswer.risk; totalFactors++; }
    if (knowledgeAnswer && knowledgeAnswer.risk) { riskScore += knowledgeAnswer.risk; totalFactors++; }
    if (lossAnswer && lossAnswer.risk) { riskScore += lossAnswer.risk; totalFactors++; }
    if (returnRiskAnswer && returnRiskAnswer.risk) { riskScore += returnRiskAnswer.risk; totalFactors++; }

    const averageRisk = totalFactors > 0 ? riskScore / totalFactors : 5;

    // Allocation basée sur le profil de risque
    let allocation = { sukuk: 0, scpi: 0, gfi: 0 };

    if (averageRisk <= 3) { // Profil prudent
      allocation = { sukuk: 70, scpi: 30, gfi: 0 };
    } else if (averageRisk <= 5) { // Profil modéré
      allocation = { sukuk: 40, scpi: 50, gfi: 10 };
    } else if (averageRisk <= 7) { // Profil dynamique
      allocation = { sukuk: 30, scpi: 40, gfi: 30 };
    } else { // Profil offensif
      allocation = { sukuk: 20, scpi: 35, gfi: 45 };
    }

    const profileType = averageRisk <= 3 ? 'Prudent' : averageRisk <= 5 ? 'Modéré' : averageRisk <= 7 ? 'Dynamique' : 'Offensif';

    return { allocation, profileType, riskScore: averageRisk };
  };

  // Fonction pour traduire les termes anglais
  const translateValue = (value, type) => {
    const translations = {
      age: {
        '18-30': '18 à 30',
        '31-45': '31 à 45', 
        '46-60': '46 à 60',
        '60+': 'plus de 60'
      },
      income: {
        'less-30k': 'moins de 30k€',
        '30k-60k': '30k à 60k€',
        '60k-100k': '60k à 100k€',
        'more-100k': 'plus de 100k€'
      },
      assets: {
        'less-10k': 'moins de 10k€',
        '10k-50k': '10k à 50k€', 
        '50k-250k': '50k à 250k€',
        'more-250k': 'plus de 250k€'
      },
      objective: {
        'wealth': 'faire fructifier son patrimoine',
        'income': 'générer des revenus',
        'specific-project': 'financer un projet spécifique',
        'retirement': 'préparer sa retraite',
        'diversification': 'diversifier ses investissements'
      },
      horizon: {
        'short-term': 'court terme (moins de 3 ans)',
        'medium-term': 'moyen terme (3 à 8 ans)',
        'long-term': 'long terme (plus de 8 ans)'
      },
      lossReaction: {
        'sell-all': 'vendrait tout pour sécuriser',
        'sell-part': 'vendrait une partie',
        'wait': 'attendrait sans rien faire',
        'buy-more': 'profiterait pour investir plus'
      },
      knowledge: {
        'beginner': 'débutant',
        'intermediate': 'intermédiaire', 
        'confirmed': 'confirmé',
        'expert': 'expert'
      }
    };
    
    return translations[type]?.[value] || value;
  };

  // Vue des recommandations personnalisées
  const RecommendationsView = () => {
    const [riskFilter, setRiskFilter] = useState('tous');
    const { allocation, profileType } = calculateAllocation();

    const products = [
      {
        id: 'sukuk',
        name: 'Sukuk Fractionné',
        category: 'Finance éthique',
        description: 'Accédez à l\'investissement éthique et responsable via des parts de biens immobiliers tokenisées.',
        image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop&crop=center',
        riskLevel: 'Faible à modéré',
        expectedReturn: '4-6% par an',
        allocation: allocation.sukuk,
        color: 'from-slate-500 to-slate-600'
      },
      {
        id: 'scpi',
        name: 'SCPI (Société Civile de Placement Immobilier)',
        category: 'Immobilier',
        description: 'Investissez dans un parc immobilier locatif diversifié (bureaux, commerces) et générez des revenus locatifs réguliers.',
        image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop&crop=center',
        riskLevel: 'Modéré',
        expectedReturn: '4-5% par an',
        allocation: allocation.scpi,
        color: 'from-teal-500 to-teal-600'
      },
      {
        id: 'gfi',
        name: 'GFI (Groupement Forestier d\'Investissement)',
        category: 'Forestier',
        description: 'Participez à la gestion durable des forêts françaises. Un investissement tangible avec un impact environnemental positif.',
        image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=300&fit=crop&crop=center',
        riskLevel: 'Modéré à élevé',
        expectedReturn: '3-5% par an + valorisation',
        allocation: allocation.gfi,
        color: 'from-sky-400 to-sky-500'
      }
    ].filter(product => product.allocation > 0);

    // Fonction pour filtrer les produits par risque
    const filterProductsByRisk = (products, filter) => {
      if (filter === 'tous') return products;
      
      const riskMapping = {
        'faible': ['Très faible', 'Faible', 'Faible à modéré'],
        'modéré': ['Modéré', 'Faible à modéré', 'Modéré à élevé'],
        'élevé': ['Élevé', 'Modéré à élevé', 'Très élevé']
      };
      
      return products.filter(product => 
        riskMapping[filter]?.some(riskLevel => 
          product.riskLevel.toLowerCase().includes(riskLevel.toLowerCase())
        )
      );
    };

    const filteredProducts = filterProductsByRisk(products, riskFilter);

    return (
      <div className="soeasi-content-card">
        {/* En-tête */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3">
            <PieChart className="h-8 w-8 text-teal-600" />
            <h1 className="text-3xl font-bold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              Vos Allocations Recommandées
            </h1>
          </div>
          <button
            onClick={() => setCurrentView('simulation')}
            className="nav-button secondary"
          >
            ← Retour à la simulation
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* Profil utilisateur */}
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-6 border border-teal-200">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-blue-400 rounded-xl flex items-center justify-center text-white font-bold text-lg mr-4">
                {profileType[0]}
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800">Votre Profil</h3>
                <p className="text-lg font-semibold text-teal-600">{profileType}</p>
              </div>
            </div>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-3">
                Ce client, âgé de {translateValue(answers.find(a => a.questionId === 'ageRange')?.value, 'age')} ans avec un 
                revenu {translateValue(answers.find(a => a.questionId === 'annualIncome')?.value, 'income')} et un patrimoine financier 
                {translateValue(answers.find(a => a.questionId === 'financialAssets')?.value, 'assets')}, vise à 
                {translateValue(answers.find(a => a.questionId === 'investmentObjective')?.value, 'objective')} 
                sur un horizon {translateValue(answers.find(a => a.questionId === 'timeHorizon')?.value, 'horizon')}.
              </p>
              <p>
                Sa réaction "{translateValue(answers.find(a => a.questionId === 'lossReaction')?.value, 'lossReaction')}" face à une baisse de 15% des marchés 
                et ses connaissances de niveau "{translateValue(answers.find(a => a.questionId === 'marketKnowledge')?.value, 'knowledge')}" 
                définissent son profil de risque.
              </p>
            </div>
          </div>

          {/* Graphique d'allocation */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
            <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">Allocation Suggérée</h3>
            
            {/* Graphique simplifié avec barres */}
            <div className="space-y-4 mb-6">
              {products.map((product) => (
                <div key={product.id} className="flex items-center">
                  <div className="w-16 text-sm font-semibold text-gray-700 mr-3">
                    {product.name.split(' ')[0]}
                  </div>
                  <div className="flex-1 bg-gray-200 rounded-full h-6 mr-3">
                    <div 
                      className={`h-6 rounded-full bg-gradient-to-r ${product.color} flex items-center justify-end pr-2`}
                      style={{ width: `${product.allocation}%` }}
                    >
                      <span className="text-white text-xs font-bold">
                        {product.allocation}%
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Légende */}
            <div className="flex flex-wrap gap-4 justify-center">
              {products.map((product) => (
                <div key={product.id} className="flex items-center">
                  <div className={`w-4 h-4 rounded bg-gradient-to-r ${product.color} mr-2`}></div>
                  <span className="text-sm text-gray-600">{product.name.split(' ')[0]}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Produits recommandés */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Nos Recommandations de Produits</h2>
          <p className="text-gray-600 mb-6">Découvrez les produits sélectionnés spécialement pour votre profil</p>
          
          {/* Filtres par risque */}
          <div className="flex items-center gap-2 mb-6">
            <span className="text-sm font-medium text-gray-700">Filtrer par risque:</span>
            {[
              { key: 'tous', label: 'Tous' },
              { key: 'faible', label: 'Faible' },
              { key: 'modéré', label: 'Modéré' },
              { key: 'élevé', label: 'Élevé' }
            ].map(filter => (
              <button
                key={filter.key}
                onClick={() => setRiskFilter(filter.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  riskFilter === filter.key
                    ? 'bg-teal-500 text-white shadow-lg'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* Cartes produits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300">
                {/* Image du produit */}
                <div className="h-48 relative overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `<div class="w-full h-full bg-gradient-to-br ${product.color} flex items-center justify-center text-white text-2xl font-bold">${product.name.split(' ')[0]}</div>`;
                    }}
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                </div>
                
                {/* Contenu */}
                <div className="p-6">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{product.name}</h3>
                    <p className="text-sm text-gray-600 mb-3">{product.description}</p>
                  </div>
                  
                  {/* Informations produit */}
                  <div className="space-y-2 mb-4 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Allocation:</span>
                      <span className="font-semibold text-teal-600">{product.allocation}%</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Risque:</span>
                      <span className="font-semibold">{product.riskLevel}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Rendement:</span>
                      <span className="font-semibold text-green-600">{product.expectedReturn}</span>
                    </div>
                  </div>
                  
                  {/* Bouton souscrire */}
                  <button 
                    onClick={() => {
                      if (onStartBilanComplete) {
                        onStartBilanComplete();
                      }
                    }}
                    className="w-full bg-gradient-to-r from-teal-500 to-blue-500 text-white font-semibold py-3 rounded-lg hover:from-teal-600 hover:to-blue-600 transition-all duration-300 flex items-center justify-center space-x-2"
                  >
                    <span>Je souscris</span>
                    <ArrowRight className="h-4 w-4" />
                  </button>
                </div>
              </div>
              ))
            ) : (
              <div className="col-span-3 text-center py-8">
                <p className="text-gray-500 text-lg">Aucun produit ne correspond à ce filtre de risque.</p>
                <button 
                  onClick={() => setRiskFilter('tous')}
                  className="mt-4 px-6 py-2 bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors"
                >
                  Voir tous les produits
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Modifier le profil */}
          <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-6 border border-gray-200">
            <div className="text-center">
              <h3 className="text-lg font-bold text-gray-800 mb-2">Modifier mon profil</h3>
              <p className="text-gray-600 text-sm mb-4">
                Changez vos réponses pour ajuster vos recommandations
              </p>
              <button
                onClick={() => {
                  setCurrentView('profiling');
                  setCurrentQuestion(0);
                }}
                className="bg-gradient-to-r from-gray-500 to-gray-600 text-white font-semibold px-6 py-3 rounded-lg hover:from-gray-600 hover:to-gray-700 transition-all duration-300 flex items-center space-x-2 mx-auto"
              >
                <span>← Revoir le questionnaire</span>
              </button>
            </div>
          </div>

          {/* Bilan complet */}
          <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-6 border border-teal-200">
            <div className="text-center">
              <h3 className="text-lg font-bold text-teal-800 mb-2">Aller plus loin</h3>
              <p className="text-teal-700 text-sm mb-4">
                Analysez votre patrimoine complet et optimisez votre fiscalité
              </p>
              <button
                onClick={() => {
                  if (onStartBilanComplete) {
                    onStartBilanComplete();
                  }
                }}
                className="bg-gradient-to-r from-teal-500 to-blue-500 text-white font-semibold px-6 py-3 rounded-lg hover:from-teal-600 hover:to-blue-600 transition-all duration-300 flex items-center space-x-2 mx-auto"
              >
                <span>Bilan patrimonial complet</span>
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Vue de simulation
  const SimulationView = () => {
    // Calcul des valeurs de simulation basées sur le profil
    const calculateSimulationValues = () => {
      const savingsAnswer = answers.find(a => a.questionId === 'monthlySavings');
      const assetsAnswer = answers.find(a => a.questionId === 'financialAssets');
      const horizonAnswer = answers.find(a => a.questionId === 'timeHorizon');
      const { allocation, profileType } = calculateAllocation();

      // Capital investi basé sur l'épargne mensuelle et l'horizon
      let monthlyAmount = 500; // défaut
      if (savingsAnswer?.value === 'less-200') monthlyAmount = 150;
      else if (savingsAnswer?.value === '200-500') monthlyAmount = 350;
      else if (savingsAnswer?.value === '500-1500') monthlyAmount = 1000;
      else if (savingsAnswer?.value === 'more-1500') monthlyAmount = 2000;

      // Durée en mois
      let durationMonths = 36; // défaut 3 ans
      if (horizonAnswer?.value === 'short-term') durationMonths = 24;
      else if (horizonAnswer?.value === 'medium-term') durationMonths = 60;
      else if (horizonAnswer?.value === 'long-term') durationMonths = 120;

      const capitalInvesti = monthlyAmount * durationMonths;

      // Rendement attendu selon le profil et l'allocation
      let expectedReturn = 0.04; // 4% par défaut
      if (profileType === 'Prudent') expectedReturn = 0.035;
      else if (profileType === 'Modéré') expectedReturn = 0.045;
      else if (profileType === 'Dynamique') expectedReturn = 0.055;
      else if (profileType === 'Offensif') expectedReturn = 0.065;

      // Calcul avec intérêts composés
      const yearsInvested = durationMonths / 12;
      const valeurFinale = capitalInvesti * Math.pow(1 + expectedReturn, yearsInvested);
      const plusValue = valeurFinale - capitalInvesti;

      return {
        capitalInvesti: Math.round(capitalInvesti),
        valeurFinale: Math.round(valeurFinale),
        plusValue: Math.round(plusValue),
        rendementAnnuel: (expectedReturn * 100).toFixed(1),
        dureeAnnees: yearsInvested.toFixed(1)
      };
    };

    const simulation = calculateSimulationValues();

    return (
      <div className="soeasi-content-card">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <Calculator className="h-8 w-8 text-teal-600" />
            <h1 className="text-3xl font-bold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              Simulation personnalisée SOeasi
            </h1>
          </div>
          <div className="flex space-x-3">
            <button
              onClick={() => {
                setCurrentView('profiling');
                setCurrentQuestion(profilingQuestions.length - 1);
              }}
              className="nav-button secondary"
            >
              ← Modifier le profil
            </button>
            <button
              onClick={() => setCurrentView('recommendations')}
              className="nav-button primary flex items-center space-x-2"
            >
              <span>Mes allocations recommandées</span>
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="text-center p-4 bg-gradient-to-br from-teal-50 to-teal-100 rounded-lg">
            <div className="text-2xl font-bold text-teal-600">{simulation.capitalInvesti.toLocaleString()}€</div>
            <div className="text-sm text-gray-600">Capital investi</div>
            <div className="text-xs text-gray-500 mt-1">Sur {simulation.dureeAnnees} ans</div>
          </div>
          <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">{simulation.valeurFinale.toLocaleString()}€</div>
            <div className="text-sm text-gray-600">Valeur finale</div>
            <div className="text-xs text-gray-500 mt-1">{simulation.rendementAnnuel}% par an</div>
          </div>
          <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
            <div className="text-2xl font-bold text-purple-600">+{simulation.plusValue.toLocaleString()}€</div>
            <div className="text-sm text-gray-600">Plus-value</div>
            <div className="text-xs text-gray-500 mt-1">Gain total</div>
          </div>
        </div>

        <div className="p-6 bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg border border-teal-200">
          <div className="text-center">
            <h3 className="font-semibold text-teal-800 mb-3">Simulation terminée !</h3>
            <p className="text-teal-700 mb-6">
              Découvrez maintenant vos allocations personnalisées basées sur votre profil de risque.
            </p>
            <button
              onClick={() => setCurrentView('recommendations')}
              className="bg-gradient-to-r from-teal-500 to-blue-500 text-white font-semibold px-8 py-3 rounded-lg hover:from-teal-600 hover:to-blue-600 transition-all duration-300 flex items-center space-x-2 mx-auto text-lg"
            >
              <span>Voir mes allocations recommandées</span>
              <ArrowRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Rendu principal
  return (
    <div className="soeasi-container">
      <div className="soeasi-card">
        {currentView === 'profiling' && <ProfilingView />}
        {currentView === 'simulation' && <SimulationView />}
        {currentView === 'recommendations' && <RecommendationsView />}
      </div>
    </div>
  );
};

export default SOeasiSimulator;
